<template>
  <grid-container class="appraisal-container">
    <p>This online Assessment Tool is an opportunity for you to showcase your skills and knowledge and to better determine your fit for the position.</p>

    <p>As part of the process you will be required to participate in two assessment tests.</p>

    <br>

    <h5><u>Please follow the instructions below before you proceed:</u></h5>

    <ul>
      <li>You have <b>1 Hour and 30 Minutes</b> to complete <b>both</b> Assessments</li>
      <li>You can view a countdown of your available time at the top of the screen.</li>
      <li>Once you begin the Assessment, <b>you cannot stop or pause it</b> - so please make sure you have allocated enough time to successfully complete the assessments.</li>
      <li>Once you finish the first assessment, the countdown timer will continue running so please make sure you begin the second assessment as soon as you can.</li>
      <li>Try to keep distractions at a minimum while undergoing the assessment; such as closing all programs, including email.</li>
      <li>Once you provide your response, you will not be allowed to go back and change your answer - so please make sure you are confident with your response before continuing with the next question.</li>
      <li>You will need a stable internet connection to take part in the assessment.</li>
      <li><b>Calculators or Mobile Phones are not permitted.</b></li>
    </ul>

    <br>

    <h5><u>During the Assessment:</u></h5>

    <p>As part of the assessment process, you will be shown various questions and problems that you need to answer.</p>

    <p>For each question you have four (4) possible options.</p>

    <p>In order to provide your response and move on to the next question; you will be required to provide <b>one (1) response</b> for each question.</p>

    <p>Once you submit your response, you may proceed onto the next question</p>

    <br>

    <h5><u>Support</u></h5>
    <p>If you have any questions, please contact us at <a class="link" href="mailto:info@owiwi.co.uk">info@owiwi.co.uk</a> and we will be happy to help!</p>

    <p><b>To begin the Assessment, click on “{{ $t('TakeTheTest') }}” below.</b></p>

    <br>

    <p><b>Best of Luck!</b></p>

    <br>

    <el-button @click="openDialog" type="primary">
      {{ $t('TakeTheTest') }}
    </el-button>

    <ElDialog
      append-to-body
      title="Are You Sure?"
      custom-class="dialog-size-550"
      :visible.sync="confirmDialog"
    >

      <div class="text-center">
        <p>This is a timed assessment with one and a half hours available.
Once you begin, you will not be able to pause or stop the process.
Are you sure you are ready to begin?</p>
      </div>

      <span
        slot="footer"
        class="dialog-footer"
      >
      <ElButton
          type="secondary"
          @click="confirmDialog = false"
        >
          No
        </ElButton>
        <ElButton
          type="primary"
          @click="startTest()"
        >
          Yes
        </ElButton>
      </span>
    </ElDialog>

    <ElDialog
      append-to-body
      title="Select Language"
      custom-class="dialog-size-550"
      :visible.sync="selectLang"
    >

      <div class="text-center">
        <el-radio-group v-model="language">
          <el-radio-button label="en">English</el-radio-button>
          <el-radio-button label="el">Ελληνικά - Greek</el-radio-button>
        </el-radio-group>
      </div>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <ElButton
          type="primary"
          :disabled="!language"
          @click="selectLanguage()"
        >
          {{ $t('TakeTheTest') }}
        </ElButton>
      </span>
    </ElDialog>
  </grid-container>
</template>

<script>
import axios from '@/axios/axios'

export default {
  name: 'Start',
  computed: {
    langKey() {
      return this.$store.getters.langKey
    },

    timeUp() {
      return this.$store.getters.timeUp
    }
  },
  data() {
    return {
      confirmDialog: false,
      selectLang: false,
      language: null
    }
  },
  created() {
    if (this.timeUp) {
      this.$router.replace('/appraisal/timeup')
    }
    if (!this.langKey) {
      this.$store.commit('langKey', 'en')
    }
  },
  methods: {
    openDialog() {
      this.confirmDialog = true
    },
    startTest() {
      if (this.langKey) {
        this.confirmDialog = false
        this.selectLang = false
        this.$store.commit('startGame')
        this.$router.replace('/appraisal')
      }
      else {
        this.selectLang = true
      }
    },

    selectLanguage() {
      axios.post('game/language', {
        playerResultId: this.$store.getters.playerResultId,
        langKey: this.language
      })
        .then(res => {
          this.$store.commit('langKey', this.language)
          this.$i18n.locale = this.language
          this.startTest()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .link {
    font-weight: 600;
    text-decoration: underline;
  }
</style>
